import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

// import PropTypes from 'prop-types';
// import { useSimpledText } from 'utils/useSimpledText';
import { useTranslation } from 'react-i18next';
import { fetchPelotonStreamApi, getUserInfoApi } from 'utils/clientApis';
import { ProfilePop } from '../../../Common/ProfilePopModal';
//
import { makeStyles } from '@material-ui/styles';
import { Box, Typography } from '@material-ui/core';
import Pagination from '@mui/material/Pagination';
import CustomCircularProgress from 'views/Peloton/Common/CustomCircularProgress';
import StreamCard from './StreamCard';
import scrollToTop from 'views/Peloton/Utils/scrollToTop';

const useStyles = makeStyles(theme => ({
  root: {},
  title: {
    fontSize: '16px',
    color: '#455A64',
    fontWeight: '700',
    padding: '0px',
    [theme.breakpoints.up('md')]: {
      fontSize: '16px'
    }
  }
}));

const Stream = prop => {
  const classes = useStyles();
  const { t } = useTranslation(['page']);
  const history = useHistory();
  const location = useLocation();

  const [streamData, setStreamData] = useState();
  const [pageTotal, setPageTotal] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    handleFetchStream(0);

    // 마운트 될 때
    const currentSearch = new URLSearchParams(location.search);
    if (!currentSearch.has('page')) {
      currentSearch.set('page', '1');
      history.push({
        pathname: location.pathname,
        search: currentSearch.toString()
      });
    }

    // 언마운트 될 때 cleanup
    return () => {
      const searchParams = new URLSearchParams(location.search);
      if (searchParams.has('page')) {
        searchParams.delete('page');
      }
    };
  }, []);

  const handleFetchStream = async page => {
    try {
      //0페이지 오류 수정
      let pageIndex = page - 1;
      if (pageIndex < 0) pageIndex = 0;

      const response = await fetchPelotonStreamApi(prop.data.id, pageIndex);
      if (response.data.success) {
        setStreamData(response.data?.response.content);
        setPageTotal(response.data?.response.totalPages);
        scrollToTop();
      }
    } catch (err) {
      console.error(err);
    }
  };

  /**
   * @return : 페이지네이션 구현부.
   */
  useEffect(() => {
    // screenRef.current.scrollIntoView({ behavior: 'auto', block: 'start' });
    // 페이지 번호가 변경될 때마다 새로운 페이지 데이터를 불러옵니다.
    handleFetchStream(currentPage);
  }, [currentPage]);

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
    history.push(`?page=${newPage}`);
  };

  function decodePolyline(encoded) {
    // 이스케이프된 문자 처리
    encoded = encoded.replace(/\\\\/g, '\\');
    var points = [];
    var index = 0,
      len = encoded.length;
    var lat = 0,
      lng = 0;

    while (index < len) {
      var b,
        shift = 0,
        result = 0;
      do {
        b = encoded.charCodeAt(index++) - 63;
        result |= (b & 0x1f) << shift;
        shift += 5;
      } while (b >= 0x20);
      var dlat = result & 1 ? ~(result >> 1) : result >> 1;
      lat += dlat;

      shift = 0;
      result = 0;
      do {
        b = encoded.charCodeAt(index++) - 63;
        result |= (b & 0x1f) << shift;
        shift += 5;
      } while (b >= 0x20);
      var dlng = result & 1 ? ~(result >> 1) : result >> 1;
      lng += dlng;

      points.push({ lat: lat / 1e5, lng: lng / 1e5 });
    }
    return points;
  }

  const PolylineToSVG = ({ polyline, width, height }) => {
    const originalPoints = decodePolyline(polyline);
    const points = originalPoints.filter((_, index) => index % 5 === 0);

    let minLat = Math.min(...points.map(p => p.lat));
    let maxLat = Math.max(...points.map(p => p.lat));
    let minLng = Math.min(...points.map(p => p.lng));
    let maxLng = Math.max(...points.map(p => p.lng));

    const svgWidth = width;
    const svgHeight = height;
    const padding = width / 10;
    const svgStrokeWidth = (width / 30).toFixed(0);
    const radius = 5;

    let lngRange = maxLng - minLng;
    let latRange = maxLat - minLat;

    // 패딩을 고려한 실제 그리기 영역의 크기
    let drawWidth = svgWidth - padding * 2;
    let drawHeight = svgHeight - padding * 2;

    let scaleX = drawWidth / lngRange;
    let scaleY = drawHeight / latRange;

    let scale = Math.min(scaleX, scaleY);

    // 중앙 정렬을 위한 추가 계산
    let offsetX = (svgWidth - lngRange * scale) / 2;
    let offsetY = (svgHeight - latRange * scale) / 2;

    // path의 시작점 조정
    let path =
      'M' +
      points
        .map(
          p =>
            `${Math.round((p.lng - minLng) * scale + offsetX)},${Math.round(
              svgHeight - (p.lat - minLat) * scale - offsetY
            )}`
        )
        .join(' L');

    return (
      <svg
        width={svgWidth}
        height={svgHeight}
        viewBox={`0 0 ${svgWidth} ${svgHeight}`}
        xmlns="http://www.w3.org/2000/svg">
        <rect
          width="100%"
          height="100%"
          fill="#4DB6AC"
          rx={radius}
          ry={radius}
        />
        {/* 패딩을 고려하여 path 그리기 */}
        <path
          d={path}
          fill="none"
          stroke="#FFFFFF"
          strokeWidth={svgStrokeWidth}
        />
      </svg>
    );
  };

  /**
   * @return: 프로필 이미지 팝업
   */
  const [selectedUser, setSelectedUser] = useState();
  const [profileOpen, setProfileOpen] = useState(false);

  const handleClickProfile = prop => {
    /**
     * 1. prop에 클릭한 프로필 유저의 닉네임이 있다.
     * 2. userData.filter 동일 닉네임인 데이터를 selectedUser에 담는다.
     * 3. selectedUser를 ProfilePop 컴포넌트에 전달한다.
     */
    const selectedNickname = prop.userNickname;
    if (streamData.length >= 0) {
      const filteredData = streamData.filter(
        user => user.displayName === selectedNickname
      );
      if (filteredData) {
        setSelectedUser(filteredData[0]);
      }
    }
    setProfileOpen(true);
  };

  const getUserInfo = () =>
    getUserInfoApi(prop.data?.id, selectedUser.clubUserId);

  return (
    <div className={classes.root}>
      {streamData ? (
        <>
          <Typography className={classes.title}>활동 스트림</Typography>
          {streamData.map((card, idx) => {
            return (
              <StreamCard
                key={card.id}
                card={card}
                handleClickProfile={handleClickProfile}
                PolylineToSVG={PolylineToSVG}
              />
            );
          })}
          {profileOpen && selectedUser && (
            <ProfilePop
              openState={profileOpen}
              setOpen={setProfileOpen}
              getUserInfo={getUserInfo}
            />
          )}
          {/* 페이지네이션 컴포넌트 */}
          <Box my={2} display="flex" justifyContent="center">
            <Pagination
              count={pageTotal}
              page={currentPage}
              onChange={handleChangePage}
              shape="rounded"
              hidePrevButton
              hideNextButton
            />
          </Box>
        </>
      ) : (
        <CustomCircularProgress />
      )}
    </div>
  );
};
export default Stream;
